import React from 'react';
import { Outlet, useNavigation, useLocation } from "react-router-dom";
import Container from 'react-bootstrap/Container';

function StepContainer() {
  const navigation = useNavigation();
  const location = useLocation();

  return (
    <Container className="App-container" data-path={location.pathname}>
      <div className={navigation.state === "loading" ? "App-container-inner loading" : "App-container-inner"}>
        <Outlet />
      </div>
    </Container>
  );
}

export default StepContainer;